import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
} from 'remotion';

const PrecompositionInner = () => {
	const frame = useCurrentFrame();
	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={438}
			trimBefore={323}
			premountFor={60}
			style={{
				width: 3126,
				height: 2958,
				translate: '-1190px -492px',
				scale: 1,
			}}
		>
			<Video
				src="https://remotion.media/brand/nest-compositions.mp4"
				durationInFrames={761}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[-322, -2, -1, 2, 61, 392, 393],
					['auto', 'default', 'auto', 'default', 'auto', 'default', 'auto'],
					{
						easing: [
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
						],

						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[-323, -88, -83, 49, 434],
						[3.3, 2.9699999999999998, 3.3, 2.9699999999999998, 3.3],
						{
							easing: [Easing.step1, Easing.step1, Easing.step1, Easing.step1],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-322, -320, -319, -318, -317, -316, -315, -314, -313, -312, -311,
							-310, -309, -308, -307, -306, -305, -300, -299, -298, -297, -296,
							-295, -294, -293, -292, -291, -290, -289, -288, -282, -281, -280,
							-279, -278, -277, -276, -275, -274, -273, -272, -271, -205, -204,
							-203, -202, -201, -200, -199, -198, -197, -196, -195, -194, -193,
							-192, -191, -190, -189, -188, -187, -176, -175, -174, -173, -172,
							-171, -170, -169, -168, -167, -166, -165, -164, -163, -161, -160,
							-159, -151, -150, -149, -148, -147, -146, -145, -144, -143, -142,
							-141, -140, -139, -138, -137, -136, -135, -134, -133, -124, -123,
							-122, -121, -120, -119, -118, -117, -116, -115, -114, -113, -112,
							-111, -110, -109, -108, -107, -106, -105, -104, -103, -102, -101,
							-100, -99, -98, -97, -96, -95, -94, -93, -92, -91, -90, -81, -80,
							-79, -78, -77, -76, -75, -74, -73, -71, -70, -69, -68, -55, -54,
							-53, -51, -50, -49, -48, -47, -46, -45, -44, -43, -42, -41, -40,
							-39, -17, -16, -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5,
							-4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 16, 17, 18, 19, 20, 21,
							22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
							38, 39, 40, 41, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
							64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
							80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95,
							96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109,
							110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
							123, 124, 126, 127, 129, 130, 132, 133, 135, 136, 138, 139, 141,
							142, 144, 145, 147, 148, 150, 151, 153, 154, 155, 196, 197, 198,
							199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211,
							212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 370, 371,
							372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384,
							385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397,
							398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410,
							411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423,
							424, 425, 426,
						],
						[
							'2801.0167968749997px 3012.8484375px',
							'2801.0167968749997px 3012.8484375px',
							'2434.6007812499997px 2239.3078124999997px',
							'2434.6007812499997px 2239.3078124999997px',
							'2262.74296875px 1861.7671874999999px',
							'2188.634765625px 1662.7488281249998px',
							'2159.87578125px 1501.9382812499998px',
							'2158.908984375px 1406.973046875px',
							'2158.4191406249997px 1329.216796875px',
							'2156.62734375px 1284.563671875px',
							'2154.5390625px 1249.681640625px',
							'2152.8890625px 1235.6050781249999px',
							'2152.4894531249997px 1232.330859375px',
							'2152.644140625px 1231.067578125px',
							'2153.5078125px 1226.59453125px',
							'2154.25546875px 1223.19140625px',
							'2154.30703125px 1222.93359375px',
							'2154.30703125px 1222.93359375px',
							'2154.5519531249997px 1223.2945312499999px',
							'2154.5519531249997px 1223.2945312499999px',
							'2155.28671875px 1224.3902343749999px',
							'2156.382421875px 1225.524609375px',
							'2156.9109375px 1226.3109375px',
							'2157.078515625px 1226.478515625px',
							'2157.465234375px 1227.045703125px',
							'2157.890625px 1227.896484375px',
							'2158.238671875px 1228.60546875px',
							'2158.599609375px 1229.32734375px',
							'2158.9347656249997px 1230.010546875px',
							'2158.9347656249997px 1230.1265624999999px',
							'2158.9347656249997px 1230.1265624999999px',
							'2159.025px 1230.1265624999999px',
							'2159.398828125px 1230.1265624999999px',
							'2159.759765625px 1230.4875px',
							'2159.862890625px 1230.590625px',
							'2160.069140625px 1230.796875px',
							'2160.069140625px 1230.796875px',
							'2161.16484375px 1231.4156249999999px',
							'2161.16484375px 1231.4156249999999px',
							'2161.4484374999997px 1231.505859375px',
							'2161.78359375px 1231.505859375px',
							'2161.809375px 1231.505859375px',
							'2161.809375px 1231.505859375px',
							'2158.857421875px 1218.537890625px',
							'2160.59765625px 1191.27421875px',
							'2160.59765625px 1191.27421875px',
							'2164.6710937499997px 1174.36171875px',
							'2172.7921874999997px 1164.3328125px',
							'2176.1953125px 1160.43984375px',
							'2185.70859375px 1156.4566406249999px',
							'2198.302734375px 1153.58203125px',
							'2232.26953125px 1152.434765625px',
							'2261.428125px 1152.176953125px',
							'2291.4503906249997px 1159.859765625px',
							'2325.7265625px 1179.1441406249999px',
							'2404.526953125px 1249.875px',
							'2531.6027343749997px 1400.953125px',
							'2814.9515625px 1755.3035156249998px',
							'3018.842578125px 1998.5109375px',
							'3244.5187499999997px 2251.7859375px',
							'3386.9601562499997px 2404.28203125px',
							'3386.9601562499997px 2404.28203125px',
							'3386.9601562499997px 2404.991015625px',
							'3381.39140625px 2424.301171875px',
							'3367.998046875px 2496.68203125px',
							'3367.998046875px 2496.68203125px',
							'3365.4972656249997px 2558.982421875px',
							'3354.6691406249997px 2635.5140625px',
							'3316.590234375px 2685.619921875px',
							'3263.455078125px 2726.689453125px',
							'3177.20390625px 2750.8335937499996px',
							'3051.1207031249996px 2774.049609375px',
							'2881.49296875px 2795.3707031249996px',
							'2769.228515625px 2800.088671875px',
							'2634.4054687499997px 2801.77734375px',
							'2634.4054687499997px 2801.77734375px',
							'2634.4054687499997px 2801.6871093749996px',
							'2634.4054687499997px 2801.506640625px',
							'2634.4054687499997px 2801.506640625px',
							'2634.1089843749996px 2801.506640625px',
							'2634.1089843749996px 2801.506640625px',
							'2620.58671875px 2801.506640625px',
							'2518.10625px 2801.506640625px',
							'2518.10625px 2801.506640625px',
							'2152.115625px 2786.141015625px',
							'2043.03515625px 2778.8062499999996px',
							'1923.04921875px 2778.8707031249996px',
							'1919.3367187499998px 2779.08984375px',
							'1919.3367187499998px 2779.08984375px',
							'1917.699609375px 2779.14140625px',
							'1920.21328125px 2779.14140625px',
							'1928.2312499999998px 2778.1875px',
							'1938.041015625px 2776.0089843749997px',
							'1967.044921875px 2768.3003906249996px',
							'2000.2769531249999px 2756.234765625px',
							'2005.355859375px 2753.0765625px',
							'2015.4234374999999px 2746.7085937499996px',
							'2015.4234374999999px 2746.7085937499996px',
							'2010.048046875px 2753.8628906249996px',
							'1958.614453125px 2802.7828124999996px',
							'1848.0386718749999px 2881.7378906249996px',
							'1691.0953124999999px 2947.1578124999996px',
							'1555.730859375px 2986.461328125px',
							'1370.028515625px 3018.7652343749996px',
							'1345.5749999999998px 3020.260546875px',
							'1336.203515625px 3020.260546875px',
							'1332.19453125px 3019.4484374999997px',
							'1314.61171875px 3015.4781249999996px',
							'1288.301953125px 3004.4566406249996px',
							'1258.318359375px 2988.69140625px',
							'1236.971484375px 2977.528125px',
							'1219.27265625px 2971.2632812499996px',
							'1203.791015625px 2966.712890625px',
							'1167.5296875px 2956.4132812499997px',
							'1142.5992187499999px 2947.59609375px',
							'1107.0984375px 2935.37578125px',
							'1082.283984375px 2928.3890625px',
							'1066.196484375px 2924.3671875px',
							'1053.151171875px 2921.4152343749997px',
							'1043.715234375px 2920.0230468749996px',
							'1022.3167968749999px 2918.334375px',
							'985.4496093749999px 2910.4453125px',
							'944.0707031249999px 2899.681640625px',
							'935.4339843749999px 2898.25078125px',
							'929.9167968749999px 2898.057421875px',
							'922.878515625px 2898.057421875px',
							'913.5843749999999px 2898.057421875px',
							'911.0062499999999px 2898.057421875px',
							'909.3046875px 2899.1789062499997px',
							'908.6214843749999px 2899.6171875px',
							'908.53125px 2899.6171875px',
							'908.11875px 2899.6171875px',
							'908.11875px 2899.6171875px',
							'907.951171875px 2899.6171875px',
							'907.409765625px 2898.7921874999997px',
							'906.4171875px 2896.098046875px',
							'905.966015625px 2893.932421875px',
							'905.966015625px 2891.818359375px',
							'907.4226562499999px 2888.5054687499996px',
							'909.2273437499999px 2885.87578125px',
							'910.9031249999999px 2883.50390625px',
							'910.9031249999999px 2883.50390625px',
							'911.0578125px 2883.362109375px',
							'909.317578125px 2883.0914062499996px',
							'908.3636718749999px 2882.8980468749996px',
							'908.3636718749999px 2882.8980468749996px',
							'908.3636718749999px 2883.0140625px',
							'908.3636718749999px 2883.375px',
							'908.3636718749999px 2883.375px',
							'908.8921875px 2883.6328125px',
							'910.41328125px 2883.0140625px',
							'910.67109375px 2880.92578125px',
							'907.3324218749999px 2878.412109375px',
							'903.0785156249999px 2873.8101562499996px',
							'900.7839843749999px 2868.3058593749997px',
							'900.6292968749999px 2867.9449218749996px',
							'898.747265625px 2865.701953125px',
							'893.616796875px 2861.912109375px',
							'888.9632812499999px 2858.625px',
							'887.72578125px 2857.7999999999997px',
							'887.46796875px 2857.6066406249997px',
							'887.46796875px 2857.6066406249997px',
							'887.0554687499999px 2857.400390625px',
							'882.75px 2854.306640625px',
							'875.5183593749999px 2849.1375px',
							'871.728515625px 2846.2886718749996px',
							'869.9625px 2844.174609375px',
							'868.4929687499999px 2841.699609375px',
							'863.4011718749999px 2836.4660156249997px',
							'860.977734375px 2833.359375px',
							'856.2210937499999px 2826.4113281249997px',
							'851.9929687499999px 2817.181640625px',
							'845.8828125px 2793.553125px',
							'831.200390625px 2704.826953125px',
							'807.4171875px 2626.6710937499997px',
							'759.4769531249999px 2543.3976562499997px',
							'734.2113281249999px 2507.213671875px',
							'673.22578125px 2406.31875px',
							'634.3734374999999px 2301.401953125px',
							'614.9343749999999px 2187.191015625px',
							'595.946484375px 2048.9390625px',
							'575.1667968749999px 1898.0027343749998px',
							'559.27265625px 1776.469921875px',
							'552.62109375px 1657.9664062499999px',
							'551.7703124999999px 1616.2007812499999px',
							'552.144140625px 1611.7019531249998px',
							'552.169921875px 1611.5085937499998px',
							'552.169921875px 1611.5085937499998px',
							'551.821875px 1610.696484375px',
							'538.90546875px 1596.71015625px',
							'487.1109375px 1508.9507812499999px',
							'487.1109375px 1508.9507812499999px',
							'465.89296874999997px 1467.8296874999999px',
							'445.47421875px 1431.594140625px',
							'419.654296875px 1390.0347656249999px',
							'385.4296875px 1346.9671875px',
							'353.525390625px 1308.5789062499998px',
							'344.33437499999997px 1297.2351562499998px',
							'333.7125px 1285.079296875px',
							'325.398046875px 1276.06875px',
							'316.503515625px 1265.691796875px',
							'310.212890625px 1256.44921875px',
							'306.397265625px 1249.2046874999999px',
							'305.133984375px 1241.354296875px',
							'304.56679687499997px 1234.58671875px',
							'302.994140625px 1226.916796875px',
							'301.1765625px 1223.13984375px',
							'296.83242187499997px 1218.1125px',
							'294.34453125px 1213.974609375px',
							'291.3796875px 1208.844140625px',
							'288.298828125px 1204.899609375px',
							'287.03554687499997px 1203.945703125px',
							'286.932421875px 1203.868359375px',
							'286.932421875px 1203.868359375px',
							'286.958203125px 1203.842578125px',
							'287.409375px 1203.3785156249999px',
							'299.4234375px 1199.073046875px',
							'524.6999999999999px 1131.423046875px',
							'656.6999999999999px 1098.423046875px',
							'798.5999999999999px 1068.723046875px',
							'904.1999999999999px 1048.923046875px',
							'1072.5px 1019.2230468749999px',
							'1138.5px 1012.623046875px',
							'1204.5px 1006.023046875px',
							'1240.8px 1002.7230468749999px',
							'1263.8999999999999px 999.423046875px',
							'1277.1px 999.423046875px',
							'1310.1px 999.423046875px',
							'1362.8999999999999px 999.423046875px',
							'1438.8px 999.423046875px',
							'1481.6999999999998px 999.423046875px',
							'1554.3px 996.123046875px',
							'1593.8999999999999px 996.123046875px',
							'1640.1px 996.123046875px',
							'1676.3999999999999px 999.423046875px',
							'1716px 999.423046875px',
							'1749px 1002.7230468749999px',
							'1782px 1006.023046875px',
							'1791.8999999999999px 1006.023046875px',
							'1801.8px 1006.023046875px',
							'1815px 1006.023046875px',
							'1844.6999999999998px 1009.3230468749999px',
							'1861.1999999999998px 1012.623046875px',
							'1877.6999999999998px 1012.623046875px',
							'1894.1999999999998px 1015.923046875px',
							'1907.3999999999999px 1019.2230468749999px',
							'1917.3px 1022.523046875px',
							'1930.5px 1025.823046875px',
							'1953.6px 1029.123046875px',
							'1963.5px 1032.423046875px',
							'1973.3999999999999px 1032.423046875px',
							'1986.6px 1035.723046875px',
							'1999.8px 1035.723046875px',
							'2016.3px 1035.723046875px',
							'2032.8px 1039.0230468749999px',
							'2039.3999999999999px 1039.0230468749999px',
							'2055.9px 1039.0230468749999px',
							'2062.5px 1039.0230468749999px',
							'2072.4px 1039.0230468749999px',
							'2082.2999999999997px 1042.323046875px',
							'2092.2px 1042.323046875px',
							'2102.1px 1042.323046875px',
							'2108.7px 1042.323046875px',
							'2115.2999999999997px 1042.323046875px',
							'2115.2999999999997px 1042.323046875px',
							'2115.2999999999997px 1042.323046875px',
							'2118.6px 1042.323046875px',
							'2121.9px 1042.323046875px',
							'2125.2px 1042.323046875px',
							'2128.5px 1042.323046875px',
							'2128.5px 1042.323046875px',
							'2131.7999999999997px 1042.323046875px',
							'2131.7999999999997px 1042.323046875px',
							'2135.1px 1042.323046875px',
							'2138.4px 1042.323046875px',
							'2138.4px 1042.323046875px',
							'2141.7px 1042.323046875px',
							'2145px 1042.323046875px',
							'2148.2999999999997px 1042.323046875px',
							'2148.2999999999997px 1042.323046875px',
							'2148.2999999999997px 1042.323046875px',
							'2151.6px 1042.323046875px',
							'2151.6px 1042.323046875px',
							'2151.6px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2154.9px 1042.323046875px',
							'2158.58671875px 1043.895703125px',
							'2167.584375px 1045.6359375px',
							'2171.8898437499997px 1047.05390625px',
							'2185.850390625px 1049.06484375px',
							'2202.15703125px 1053.873046875px',
							'2223.9035156249997px 1067.21484375px',
							'2262.472265625px 1097.58515625px',
							'2307.202734375px 1134.336328125px',
							'2350.541015625px 1174.606640625px',
							'2380.498828125px 1205.518359375px',
							'2409.6574218749997px 1241.044921875px',
							'2422.393359375px 1263.423046875px',
							'2435.090625px 1294.4765625px',
							'2446.189453125px 1323.029296875px',
							'2460.975px 1358.9812499999998px',
							'2473.9171874999997px 1384.001953125px',
							'2485.4542968749997px 1402.7578125px',
							'2492.105859375px 1413.8824218749999px',
							'2501.387109375px 1429.8152343749998px',
							'2512.51171875px 1448.90625px',
							'2520.76171875px 1460.726953125px',
							'2524.229296875px 1464.8648437499999px',
							'2527.8515625px 1470.2273437499998px',
							'2531.035546875px 1476.2730468749999px',
							'2531.035546875px 1476.2730468749999px',
							'2531.0484375px 1476.4792968749998px',
							'2531.0484375px 1476.4792968749998px',
							'2531.0484375px 1476.7886718749999px',
							'2538.80859375px 1562.34375px',
							'2540.25234375px 1618.546875px',
							'2544.0421874999997px 1758.8999999999999px',
							'2546.916796875px 1856.3660156249998px',
							'2550.7453124999997px 1955.469140625px',
							'2551.3125px 2017.021875px',
							'2552.5757812499996px 2072.670703125px',
							'2552.5757812499996px 2134.6359374999997px',
							'2554.40625px 2191.187109375px',
							'2556.984375px 2229.871875px',
							'2559.07265625px 2266.0171875px',
							'2560.25859375px 2306.4421875px',
							'2560.3746093749996px 2341.96875px',
							'2560.3746093749996px 2370.315234375px',
							'2560.3746093749996px 2400.788671875px',
							'2560.3746093749996px 2423.2570312499997px',
							'2560.3746093749996px 2434.355859375px',
							'2560.3746093749996px 2439.383203125px',
							'2564.808984375px 2466.195703125px',
							'2574.7863281249997px 2493.6140625px',
							'2600.387109375px 2535.8566406249997px',
							'2634.0703125px 2576.86171875px',
							'2670.9890625px 2617.402734375px',
							'2699.21953125px 2649.9515625px',
							'2726.6378906249997px 2686.715625px',
							'2742.2613281249996px 2714.27578125px',
							'2753.0894531249996px 2744.33671875px',
							'2756.7374999999997px 2765.6320312499997px',
							'2757.3820312499997px 2785.109765625px',
							'2757.3820312499997px 2803.517578125px',
							'2760.1535156249997px 2834.480859375px',
							'2761.06875px 2846.68828125px',
							'2761.3265625px 2850.851953125px',
							'2762.58984375px 2858.13515625px',
							'2767.836328125px 2872.4308593749997px',
							'2774.7199218749997px 2885.5148437499997px',
							'2780.5851562499997px 2894.6285156249996px',
							'2787.043359375px 2904.02578125px',
							'2796.556640625px 2916.375px',
							'2804.3683593749997px 2924.612109375px',
							'2810.3882812499996px 2929.8199218749996px',
							'2812.91484375px 2932.90078125px',
							'2816.330859375px 2939.08828125px',
							'2819.656640625px 2949.052734375px',
							'2821.9253906249996px 2960.3707031249996px',
							'2823.549609375px 2972.24296875px',
							'2824.142578125px 2979.139453125px',
							'2824.61953125px 2982.491015625px',
							'2825.4703124999996px 2986.822265625px',
							'2825.818359375px 2989.2457031249996px',
							'2826.3984375px 2991.8882812499996px',
							'2826.514453125px 2994.092578125px',
							'2826.83671875px 2996.4515625px',
							'2826.9140625px 2996.9671875px',
							'2826.9140625px 2997.09609375px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const Precomposition = Interactive.withSchema({
	Component: PrecompositionInner,
	componentName: 'Precomposition',
	schema: {},
	wrapInSequence: true,
	layout: 'absolute-fill',
});

export const NestingCompositionsPreview = () => {
	return (
		<>
			<Precomposition name={'Precomposition'} durationInFrames={158} />
			<Precomposition
				name={'Precomposition'}
				from={158}
				trimBefore={186}
				premountFor={60}
			/>
		</>
	);
};

export const NestingCompositions = () => {
	return (
		<>
			<Composition
				id={'NestingCompositions'}
				component={NestingCompositionsPreview}
				width={1920}
				height={1080}
				fps={60}
				durationInFrames={339}
			/>
			<Composition
				id="Precomposition"
				component={Precomposition}
				durationInFrames={761}
				fps={60}
				width={1920}
				height={1080}
			/>
		</>
	);
};
